import DynamicIcon from "./dynamic-icon";
import FitButton from "./fit-button";
import ButtonContent from "./button-content";
import {ArrowRight} from "lucide-react";
import ToolTipContext from "../../contexts/tooltip-context";
import {useContext} from "react";

const TimedTooltip = ({ additionalclasses, title, body }) => {
    const { setActiveTooltip, nextTooltip, isLastTooltip } = useContext(ToolTipContext);
    
    return (
        <div className={`absolute gap-[16px] items-center w-[318px] p-[16px] rounded-[8px] lg:block hidden bg-white-50 dark:bg-grey-600 custom-shadow z-[9999] ${additionalclasses}`}>
            <div className="grid gap-[4px]">
                <div className="flex justify-between items-center custom-text-grey-800">
                    <p className="text-[14px] poppins-medium ">{title}</p>
                    {/* <DynamicIcon onClick={()=>setActiveTooltip(null)} name="x" size={20} color="custom-text-grey-800 cursor-pointer" /> */}
                </div>
                <p className="text-[14px] custom-text-grey-500 leading-[21px] w-[258px]">{body}</p>
            </div>
            <div className="flex justify-between items-center">
                <span onClick={()=>setActiveTooltip(null)} className="text-[14px] custom-text-grey-500 leading-[21px] poppins-medium">Skip</span>
                <FitButton onClick={nextTooltip}>
                    <ButtonContent imagePosition={1} icon={isLastTooltip ? '': <ArrowRight size={15} />}>{isLastTooltip ? 'Got it' : 'Next'}</ButtonContent>
                </FitButton>
            </div>
        </div>
    )
}
    export default TimedTooltip;